// ============================================================================
// home-page-setting-client-mod -- Admin Registrar
//
// 注册"首页设置" Slot 到 admin-client-mod 的管理员中心。
// ============================================================================
import { HomePageSettingPanel } from './admin/home-page-setting-panel.js';
import { HomePageIcon } from './icons.js';
/**
 * 首页设置 Admin Registrar
 */
export class HomePageSettingAdminRegistrar {
    constructor(deps) {
        const { adminSlots, fetchService } = deps;
        // 注册"首页设置" slot 到管理员中心
        adminSlots.registerSlot({
            id: 'home-page-setting',
            label: '首页设置',
            icon: HomePageIcon,
            component: () => React.createElement(HomePageSettingPanel, { fetchService }),
            order: 50,
            modName: 'home-page-setting-client',
        });
    }
}
// React import for createElement
import * as React from 'react';
//# sourceMappingURL=home-page-setting-admin-registrar.js.map